import { UrlHash } from "@anyways-open/url-hash";
export class UrlHashHandler {
    constructor(key) {
        this.key = key;
        // eslint-disable-next-line no-empty
        if (typeof UrlHashHandler.state === "undefined") {
        }
        else {
            UrlHashHandler.state[this.key] = undefined;
        }
        UrlHashHandler.state = UrlHash.read();
    }
    update(value, force = false) {
        const currentValue = UrlHashHandler.state[this.key];
        if (!force) {
            if (currentValue === value)
                return;
        }
        if (typeof value === "undefined") {
            delete UrlHashHandler.state[this.key];
        }
        else {
            UrlHashHandler.state[this.key] = value;
        }
        UrlHashHandler.stateDirty = true;
    }
    getState() {
        return UrlHashHandler.state[this.key];
    }
}
UrlHashHandler.state = undefined;
UrlHashHandler.stateDirty = false;
UrlHashHandler.updateTimer = setInterval(() => {
    if (!UrlHashHandler.stateDirty)
        return;
    UrlHash.write(UrlHashHandler.state);
    UrlHashHandler.stateDirty = false;
}, 500);
